namespace SorAraBul.Web.Modules {
    export namespace TenantsPermissions {
        export const Insert = "Tenants:Insert";
        export const Update = "Tenants:Update";
        export const Delete = "Tenants:Delete";
        export const View = "Tenants:View";
    }
}
